import { render } from "./KeyboardModal.vue?vue&type=template&id=32722d3e"
import script from "./KeyboardModal.vue?vue&type=script&lang=js"
export * from "./KeyboardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__